import script from "./OperationalLearning.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationalLearning.vue?vue&type=script&setup=true&lang=js"

import "./OperationalLearning.vue?vue&type=style&index=0&id=5e45267d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e45267d"]])

export default __exports__